var map = {
	"./collect.png": "0c2c",
	"./exit.png": "3691",
	"./history.png": "baef",
	"./idea.png": "c180",
	"./last.png": "e0f2",
	"./next.png": "81e7",
	"./next_disable.png": "a765",
	"./noIdea.png": "c7da",
	"./noUnderline.png": "6b93",
	"./note.png": "787d",
	"./underline.png": "c5cf",
	"./xinde.png": "93d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fe3";